import script from "./receita.vue?vue&type=script&setup=true&lang=js"
export * from "./receita.vue?vue&type=script&setup=true&lang=js"

import "./receita.vue?vue&type=style&index=0&id=63e38e87&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63e38e87"]])

export default __exports__